import styled from "styled-components"

export const NodeOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1.5rem 0;
`

export const NodeOption = styled.button`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1.2rem 1.5rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  background: ${(p) => p.theme.colors.white};
  cursor: pointer;
  text-align: left;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    background: ${(p) => p.theme.colors.turquoiseLighter};
  }
`

export const NodeOptionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  flex-shrink: 0;
`

export const NodeOptionLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;

  strong {
    font-size: 1.4rem;
    color: ${(p) => p.theme.colors.black};
  }

  span {
    font-size: 1.2rem;
    color: ${(p) => p.theme.colors.greyDarker};
  }
`
